<template>
  <div
    class="loginPage"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="title">
      <div class="logo flex-rowc">
        <el-image
          style="width: 253px; height: 28px"
          :src="require('@/assets/images/login_logo1.png')"
        ></el-image>
        <el-image
          style="width: 101px; height: 28px"
          :src="require('@/assets/images/login_logo2.png')"
        ></el-image>
      </div>
      <div class="logo2 flex-rowc">
        <el-image
          style="width: 552px; height: 60px"
          :src="require('@/assets/images/login_logo3.png')"
        ></el-image>
      </div>
      <div class="txt flex-rowc">
        <h1>密码找回</h1>
        <span class="left">[</span> SPR Plus
        全境新零售分销&供销存一体化管理服务平台 <span class="right">]</span>
      </div>
    </div>
    <div class="form_wrap" v-if="step == 1">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="95px"
        label-position="left"
        class="demo-ruleForm"
      >
        <el-form-item label="手机号" prop="mobile">
          <el-input
            v-model="ruleForm.mobile"
            placeholder="输入注册时使用的手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input
            v-model="ruleForm.code"
            placeholder="请输入短信验证码"
          ></el-input>
          <div
            class="vifity_btn"
            :class="{ disable: isDisable }"
            @click="handleSendVifity"
          >
            {{ countText }}
          </div>
        </el-form-item>
        <!-- <el-form-item label="密码" prop="loginpwd">
          <el-input
            v-model="ruleForm.loginpwd"
            placeholder="请输入密码（6~18位英文加数字，区分大小写）"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="loginpwd2">
          <el-input
            v-model="ruleForm.loginpwd2"
            placeholder="请再次输入密码，请确保与首次输入的密码保持一致"
          ></el-input>
        </el-form-item> -->

        <div class="btn_group flex-rowc">
          <div
            class="primary-button"
            @click="handleNextOne('ruleForm')"
            v-loading.fullscreen.lock="fullscreenLoading"
          >
            下一步
          </div>
          <div class="primary-button-plain flex-rowc" @click="handleReturn">
            返回
          </div>
        </div>
      </el-form>
    </div>

    <div class="form_wrap" v-if="step == 2">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="submitParams"
        label-width="95px"
        label-position="left"
        class="demo-ruleForm"
      >
        <el-form-item label="密码" prop="pwd">
          <el-input
            v-model="submitParams.pwd"
            placeholder="请输入密码（6~18位英文加数字，区分大小写）"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="pwd2">
          <el-input
            v-model="submitParams.pwd2"
            placeholder="请再次输入密码，请确保与首次输入的密码保持一致"
          ></el-input>
        </el-form-item>

        <div class="btn_group flex-rowc">
          <div
            class="primary-button"
            @click="handleSubmit('submitParams')"
            v-loading.fullscreen.lock="fullscreenLoading"
          >
            保存设置
          </div>
          <div class="primary-button-plain flex-rowc" @click="step = 1">
            返回
          </div>
        </div>
      </el-form>
    </div>

    <!-- 扫码登录 start -->
    <div class="custom_dialog" v-if="isShow">
      <div class="custom_wrap">
        <div class="close_icon" @click="isShow = false">
          <i class="iconfont icon-guanbi"></i>
        </div>
        <div class="main flex-cowc">
          <div class="verify-code flex-rowc">
            <canvas
              id="canvas"
              width="100"
              height="43"
              @click="changeCode()"
              style="border: 1px solid #ccc; border-radius: 5px"
            ></canvas>
            <div class="verify-code-change" @click="changeCode()">
              <el-link style="color: #5c5959" type="info" :underline="false"
                >看不清，</el-link
              ><el-link type="primary" :underline="false">换一张</el-link>
            </div>
          </div>
          <div class="verify-input flex-rowc">
            <el-input
              v-model="verifyCode"
              placeholder="请输入验证码"
            ></el-input>
          </div>
        </div>
        <div class="dialog_footer flex-rowc">
          <div class="btn" @click="handleVerfity">确认</div>
          <div class="close" @click="isShow = false">←关闭</div>
        </div>
      </div>
    </div>
    <!-- 扫码登录 end -->
  </div>
</template>
<script>
import { sendVerfity, verifyPhoto, resetPass } from "../api/api";
export default {
  name: "login",
  data() {
    var validatorloginpwd2 = (rule, value, callback) => {
      if (value != this.submitParams.pwd) {
        callback(new Error("请输入再次输入正确的密码"));
      } else {
        callback();
      }
    };
    return {
      step: 1,
      fullscreenLoading: false,
      numCode: "",

      isDisable: false,
      countText: "获取验证码",
      ruleForm: {
        mobile: "",
        code: "",
      },
      rules: {
        mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        code: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
      },
      submitParams: {
        mobile: '',
        token: '',
        pwd: '',
        pwd2: '',
      },
      rulesSubmitParams: {
        pwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 18, message: "请输入6~18位密码", trigger: "blur" },
        ],
        pwd2: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { min: 6, max: 18, message: "请输入6~18位密码", trigger: "blur" },
          { required: true, validator: validatorloginpwd2, trigger: "blur" },
        ],
      },
      verifyCode: "",

      loading: false,
      isShow: false,
    };
  },
  created() {},
  mounted() {
    // this.drawCode([]);
  },
  methods: {
    // 提交验证码
    handleNextOne(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true;
          let { ruleForm } = this;
          verifyPhoto(ruleForm).then((res) => {
            if (res.result) {
            //   let message = this.$message.success(res.message);
              this.fullscreenLoading = false;
              setTimeout(() => {
                this.submitParams.token = res.code
                this.step = 2;
              }, 500);
            } else {
              this.fullscreenLoading = false;
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 修改密码
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true;
          let { submitParams ,ruleForm } = this;
          submitParams.mobile = ruleForm.mobile
          resetPass(submitParams).then((res) => {
            if (res.result) {
              let message = this.$message.success(res.message);
              this.fullscreenLoading = false;
              setTimeout(() => {
                message.close();
                this.$router.back()
              }, 1500);
            } else {
              this.fullscreenLoading = false;
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 验证码
    handleSendVifity() {
      let { isDisable, isVerify, ruleForm } = this;
      if (isDisable) return;
      let photoReg = /^1[3-9]\d{9}$/;
      if (ruleForm.mobile == "") {
        this.$message.warning("请输入手机号！");
        return;
      } else if (!photoReg.test(ruleForm.mobile)) {
        this.$message.warning("请输入正确的手机号！");
        return;
      }
      if (!isVerify) {
        this.isShow = true;
        this.$nextTick(() => {
          this.drawCode([]);
        });
        return;
      }
    },
    // 发送验证码
    handleVerfity() {
      let { verifyCode, numCode, ruleForm } = this;
      if (verifyCode != numCode.join("")) {
        this.$message.warning("验证码不正确，请重新输入");
        return;
      }
      let params = {
        cellphone: ruleForm.mobile,
        screen: "SPR用户修改密码",  // appid：0-维应SPR开发版用户修改密码、3-维应企微SPR开发版用户修改密码、2001-维应SPR用户修改密码、2002-维应企微SPR用户修改密码、3001-月峰教育企微SPR用户修改密码
      };
      // 关闭验证弹窗 start
      this.isShow = false;
      this.verifyCode = "";
      let i = 60;
      sendVerfity(params)
        .then((res) => {
          if (res.result) {
            this.verifyCode = "";
            const timer = setInterval(() => {
              i--;
              if (i <= 0) {
                this.countText = `重发验证码`;
                this.isDisable = false;
                clearInterval(timer);
              } else {
                this.countText = `重发验证码（${i--}）s`;
                this.isDisable = true;
              }
            }, 1000);
            // this.$toast.success(res.msg);
          } else {
            this.verifyCode = "";
            this.$message.error(res.msg || "服务器报错，请稍后～");
          }
        })
        .catch((err) => {
          this.$message.error(err.mess || "服务器报错，请稍后～");
          // obj.refresh();
          // this.isVerify = false;
          // this.isShow = false
        });
    },
    // 验证码
    changeCode() {
      this.drawCode([]);
    },
    drawCode(show_num) {
      var canvas_width = document.getElementById("canvas").clientWidth;
      var canvas_height = document.getElementById("canvas").clientHeight;
      var canvas = document.getElementById("canvas"); //获取到canvas的对象，演员
      var context = canvas.getContext("2d"); //获取到canvas画图的环境，演员表演的舞台
      canvas.width = canvas_width;
      canvas.height = canvas_height;
      var sCode = "0,1,2,3,4,5,6,7,8,9";
      // var sCode = "A,B,C,E,F,G,H,J,K,L,M,N,P,Q,R,S,T,W,X,Y,Z,1,2,3,4,5,6,7,8,9,0,q,w,e,r,t,y,u,i,o,p,a,s,d,f,g,h,j,k,l,z,x,c,v,b,n,m";
      var aCode = sCode.split(",");
      var aLength = aCode.length; //获取到数组的长度
      let newNum = [];
      for (var i = 0; i <= 3; i++) {
        var j = Math.floor(Math.random() * aLength); //获取到随机的索引值
        var deg = (Math.random() * 30 * Math.PI) / 180; //产生0~30之间的随机弧度
        var txt = aCode[j]; //得到随机的一个内容
        show_num[i] = txt;
        var x = 10 + i * 20; //文字在canvas上的x坐标
        var y = 20 + Math.random() * 8; //文字在canvas上的y坐标
        context.font = "bold 23px 微软雅黑";

        context.translate(x, y);
        context.rotate(deg);

        context.fillStyle = this.randomColor();
        context.fillText(txt, 0, 0);

        context.rotate(-deg);
        context.translate(-x, -y);
        newNum.push(show_num[i]);
      }
      this.numCode = newNum;
    },
    randomColor() {
      //得到随机的颜色值
      var r = Math.floor(Math.random() * 256);
      var g = Math.floor(Math.random() * 256);
      var b = Math.floor(Math.random() * 256);
      return "rgb(" + r + "," + g + "," + b + ")";
    },

    // 返回上一页
    handleReturn() {
      this.$router.back();
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll); //销毁滚动事件
  },
};
</script>
<style lang="less" scoped>
.loginPage {
  padding: 0 60px;
  .title {
    padding: 35px 0 26px;
    border-bottom: 6px solid #6e5d87;
    .logo2 {
      margin: 18px 0;
    }
    .txt {
      font-size: 18px;
      color: #000000;
      position: relative;
      span {
        &.left {
          margin-right: 15px;
        }
        &.right {
          margin-left: 15px;
        }
      }
      h1 {
        position: absolute;
        left: 0;
        font-size: 20px;
        color: #444444;
      }
    }
  }
  .form_wrap {
    // height: 62vh;
    // overflow-y: scroll;
    width: 700px;
    margin: 60px auto 0;
    &::-webkit-scrollbar {
      display: none;
    }
    .verify_wrap {
      margin-top: 35px;
      margin-bottom: 25px;
      .verify-code {
        margin-bottom: 20px;
        .verify-code-change {
          margin-left: 20px;
        }
      }
    }
    .primary-button-plain {
      margin-left: 40px;
      .icon-erweima {
        font-size: 22px;
        margin-right: 5px;
      }
    }
    .tip {
      font-size: 16px;
      color: #828282;
      margin: 35px auto;
      p {
        color: #ff0012;
        cursor: pointer;
      }
    }
    .vifity_btn {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      padding: 0 20px;
      cursor: pointer;
      background: #e4e4e4;
      font-size: 14px;
    }
    .btn_group {
      margin-top: 50px;
    }
  }
  .custom_dialog {
    .custom_wrap {
      width: 500px;
      .main {
        margin: 10px 0 40px;
        .verify-code {
          .verify-code-change {
            margin-left: 10px;
          }
        }
        .verify-input {
          width: 200px;
          margin: 20px auto 0;
        }
      }
      .dialog_footer {
        height: 50px;
        .btn {
          width: 120px;
          height: 40px;
          background: #f62560;
          border-radius: 25px;
          text-align: center;
          line-height: 40px;
          color: #fff;
          margin-right: 20px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>